import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useEffect, useState } from "react";
import "./exitbutton.css";

function ExitButton() {
  const [navigationUrl, setNavigationUrl] = useState();
  const [showBack, setShowBack] = useState(false);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const url = urlParams.get("exit_url");
    const showB = urlParams.get("show_back_button");
    if (showB) {
      setNavigationUrl(url);
      setShowBack(true);
    }
  }, []);

  if (!showBack) {
    return null;
  }

  return (
    <div className="header-left">
      <div
        onClick={() => {
          window.navigation_handler.postMessage("navigate=" + navigationUrl);
        }}
      >
        <ArrowBackIosNewIcon style={{ color: "white" }} />
      </div>
    </div>
  );
}

export default ExitButton;
